import BigDrawer from "@/components/Drawer/BigDrawer";
import { loadAllAgent } from "@/redux/rtk/features/CRM/agent/agentSlice";
import { loadAllContact } from "@/redux/rtk/features/CRM/contact/contactSlice";
import { loadAllOpportunitySource } from "@/redux/rtk/features/CRM/opportunitySource/opportunitySourceSlice";
import { loadAllOpportunityStage } from "@/redux/rtk/features/CRM/opportunityStage/opportunityStageSlice";
import { loadAllOpportunityType } from "@/redux/rtk/features/CRM/opportunityType/opportunityTypeSlice";
import { loadAllStaff } from "@/redux/rtk/features/hrm/user/userSlice";
import { Form, Input, Select } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import AddCompany from "../Company/AddCompany";
import AddContact from "../Contact/AddContact";
import AddOpportunityType from "../Setup/OpportunitySetup/OpportunityType/AddOpportunityType";
import AddOpportunitySource from "../Setup/OpportunitySetup/OpportunitySource/AddOpportunitySource";
import AddOpportunityStage from "../Setup/OpportunitySetup/OpportunityStage/AddOpportunityStage";

const AdditionalOpportunityInformation = ({
  createAs,
  form,
  opportunity,
  drawer,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { list: companyList, loading: companyLoading } = useSelector(
    (state) => state.agent
  );
  const { list: opportunitySourceList, loading: opportunitySourceLoading } =
    useSelector((state) => state.opportunitySource);
  const { list: opportunityStageList, loading: opportunityStageLoading } =
    useSelector((state) => state.opportunityStage);
  const { list: opportunityTypeList, loading: opportunityTypeLoading } =
    useSelector((state) => state.opportunityType);

  const { list: contactList, loading: contactLoading } = useSelector(
    (state) => state.contact
  );
  const { loading: opportunityLoading } = useSelector(
    (state) => state.opportunity
  );

  useEffect(() => {
    dispatch(loadAllOpportunitySource());
    dispatch(loadAllOpportunityType());
    dispatch(loadAllAgent());
    dispatch(loadAllOpportunityStage());
    dispatch(loadAllContact());
  }, [dispatch]);

  useEffect(() => {
    if (opportunity) {
      form.setFieldsValue({
        ...opportunity,
      });
    }
  }, [form, opportunity]);
  // Remove all fields as per the diagram - Deal form should only have the fields in OpportunityInformation
  return (
    <div className="grid grid-cols-2 gap-3">
      {/* All fields removed - Deal form only contains fields from OpportunityInformation */}
      <div className="col-span-2 text-center text-gray-500 py-4">
        All additional information fields have been removed. Deal form now matches the diagram requirements.
      </div>
    </div>
  );
};

export default AdditionalOpportunityInformation;
